export enum eRoles {
    Admin = 'Administrator',
    Logistics = 'Logistics'
}

export enum eOrderStatus {
    Pending = 1,
    Confirmed = 2,
    InProgress = 3,
    PartialDone = 4,
    Done = 5,
    Cancel = 6
}

export enum eSupplyOrderStatus {
    Pending = 1,
    InProgress = 2,
    Done = 3
}